import parse from "../parse";
import { CourseHolidaysClass } from "../../constants/classes";

export default async function getCourseHolidays() {
  const courseHolidays = parse.Object.extend(CourseHolidaysClass);
  const query = new parse.Query(courseHolidays);
  return await query.find();
}
